<template>
  <div ref="container" class="zoox-component zoox-camera-stream">
    <video
      v-show="availableStream"
      ref="webcam"
      autoplay
      class="zoox-camera-stream-video"
      :class="{mirror}"
    ></video>
    <p v-show="!availableStream" class="body3 error-text">
      <z-icon color="var(--red)">$warning_rounded</z-icon>
      {{ $t('video_stream_not_available') }}
    </p>
  </div>
</template>

<script>
/**
 * @displayName Camera Stream
 */
export default {
  name: 'ZCameraStream',
  props: {
    /**
     * A stream da câmera selecionada
     */
    stream: {
      default: null,
    },
    /**
     * Flag para espelhar a imagem do stream, voltado mais para selfies
     */
    mirror: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para colocar em estado de loading
     */
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      height: 0,
      width: 0,
    }
  },
  computed: {
    availableStream() {
      return !!this.stream
    },
  },
  watch: {
    availableStream(isAvailable) {
      if (isAvailable) {
        this.play()
      }
    },
  },
  methods: {
    play() {
      const webcam = this.$refs.webcam

      webcam.srcObject = this.stream
      webcam.play()
      webcam.oncanplay = () => this.showStreamingVideo()
    },
    /**
     * Pega a imagem de maneira assíncrona
     *
     * @public
     */
    async getImage() {
      if (!this.availableStream) {
        return null
      }
      const videoDevice = this.stream.getVideoTracks()[0]
      const captureDevice = new ImageCapture(videoDevice)

      if (captureDevice) {
        const photoBlob = await captureDevice.takePhoto()

        this.play()
        return URL.createObjectURL(photoBlob)
      }
    },
    showStreamingVideo() {
      if (this.availableStream) {
        const webcam = this.$refs.webcam

        webcam.setAttribute('width', webcam.videoWidth)
        // webcam.setAttribute('height', webcam.videoHeight)
      }
    },
  },
  i18n: {
    messages: {
      pt: {
        video_stream_not_available: 'imagem de vídeo não disponivel',
      },
      es: {
        video_stream_not_available: 'imagen de video no disponible',
      },
      en: {},
      fr: {
        video_stream_not_available: 'Flux vidéo non disponible',
      },
      tr: {
        video_stream_not_available: 'Video akışı mevcut değil',
      },
    },
  },
}
</script>

<style lang="scss" scoped>
#photo {
  display: none;
}

.zoox-camera-stream {
  height: 100%;
  overflow: hidden;
}

.zoox-camera-stream-video {
  width: 100%;
  height: 100%;

  &.mirror {
    transform: scaleX(-1);
  }
}

.zoox-camera-stream-canvas {
  display: none;
}

.error-text {
  color: var(--red);
  font-weight: bold;
  width: 100%;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
}
</style>
